import { accountsRoyaltyGetters } from "./accounts/getters";
import { contractsRoyaltyGetters } from "./contracts/getters";
import { dealsRoyaltyGetters } from "./deals/getters";
import { recoupableGetters } from "./recoupable/getters";
import { statementGetters } from './statement/getters';
import { RoyaltyModulePluginStore } from "./plugin-store";

export const getters = {
  ...accountsRoyaltyGetters,
  ...contractsRoyaltyGetters,
  ...dealsRoyaltyGetters,
  ...statementGetters,
  ...recoupableGetters,
  ...RoyaltyModulePluginStore.getters
};
